<template>
  <div>
    <!-- top sales store -->
  </div>
</template>

<script>
// import { useToast } from 'vue-toastification';

export default {
  name: 'ReceiptsStore',
  props:{
    selectedTimePeriod:{default:'day'},
  },
  computed:{
    dataKey(){return 'receipts'},
    apiRoutes(){return ['/Daily/RCGB/Receipt/']},
    apiRoute(){return this.apiRoutes[0]},
    dataArray(){return this[this.dataKey]},
    
    
    dataKeys(){return this.dataArray.length > 0 ? this.$util.keys(this.dataArray) : []},
    deptKeys(){return this.dataArray.length > 0 ? this.$util.uniqueValuesForKey(this.dataArray, "Dept_ID") : []},

  },
  data(){
    return {
      receiptNumber: "",
      receipts: [],
      error: false,
      isLoading: false,
      reloadInterval: undefined,
      reloadTimeout: 1000 * 15,
      dow: false,
      meta:{
      }
    }
  },
  mounted(){
    // this.getData();
    // this.reloadInterval = setInterval(this.getData, this.reloadTimeout)
  },
  unmounted() {
    // clearInterval(this.reloadInterval)
  },
  watch: {
  },
  methods:{
    getData(cb){
      console.log(`Getting Data for store name - ${this.$options.name}`);
      // Check if dataKey is an array set in data()
      if (this[this.dataKey] === undefined || !Array.isArray(this[this.dataKey])){
        console.log('DEBUG', 'dataKey failed', this[this.dataKey])
        return;
      }
      // this.transactions = undefined;
      this.$set(this, 'isLoading', true)
      // this.isLoading = true;
      
      // Not used really
      const options = {limit: 25, dow:this.dow};
      
      this.$axios.post(this.apiRoute + this.formatReceiptNumber(this.receiptNumber), options).then((r)=>{
        
        this[this.dataKey] = [];
        this.error = false
        this.isLoading = false;

        // If the data_array is empty, set it to a default array
        r.data.forEach(receipt =>{
          console.log('DEBUG', 'data_array', receipt.data_array)
          if(receipt.data_array === "" || receipt.data_array === undefined){
            receipt.data_array = ["0", ""];
          } else {
            receipt.data_array = JSON.parse(receipt.data_array);
          }
          console.log('DEBUG', 'data_array', receipt.data_array)
        })
        this[this.dataKey] = r.data
        typeof cb === "function" ? cb() : 1+1;
        
      }).catch(err =>{
        console.log('Error fetching', this.apiRoute, err)
        this.error = true
      })
    },

    
    saveReceipt(receipt, cb){
      // const toast = useToast();

      console.log('DEBUG', 'saveReceipt', receipt)

      // Cutoff the string for the second element of data_array to be only 7 characters long
      receipt.data_array[1] = receipt.data_array[1].slice(0, 7);

      this.$axios.put(this.apiRoutes[0] + receipt.Invoice_Number, {data_array : receipt.data_array}).then(r =>{
        console.log('DEBUG', 'saveReceipt', 'did update', r)
        this.$toast.success(`Receipt ${receipt.Invoice_Number} saved.`, {
          position: 'top-left',
          timeout: 2000
        })
        typeof cb === "function" ? cb() : 1+1;
        
        // toast.success('Receipt saved successfully!', {
        //   position: 'top-right',
        //   timeout: 3000
        // })
      }).catch(err =>{
        console.log('DEBUG', 'saveReceipt', 'update failed', err)
      })
    },

    formatReceiptNumber(receiptNum){
      return receiptNum.replace(/^I1001-/, '').replace(/\D/g, '');
    },

    // Put Example, to be refactored
    // countHandler: async function(item, ID, count){
    //   console.log('DEBUG', 'countHandler', item)
    //   this.$axios.put(this.apiRoutes[1] + ID, {ID, count, ts:new Date().toISOString()}).then(r =>{
    //     console.log('DEBUG', 'countHandler', 'did update', r)
    //   }).catch(err =>{
    //     console.log('DEBUG', 'countHandler', 'update failed', err)
    //   })
    // }

    // Helpters
    
  },
}
</script>